import { BASE_APP_URL } from 'app/developer-v3/constants';

type Link = {
  title: string;
  href: string;
};

const routePrefix = `${BASE_APP_URL}/partner-settings`;

export const ROUTE_PARTNER_SETTINGS: Link = {
  title: 'Partner Profile',
  href: `${routePrefix}/profile`,
};
export const ROUTE_EMAIL_SETTINGS: Link = {
  title: 'Email Preferences',
  href: `${routePrefix}/email`,
};
export const ROUTE_DEPLOY_KEYS: Link = {
  title: 'Deploy Keys',
  href: `${routePrefix}/deploy-keys`,
};
